import { Select } from 'foundations-components/transitional/components/Select';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MILLISECONDS, SECONDS, MINUTES, HOURS, DAYS } from 'reporting-data/constants/timeUnits';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { jsx as _jsx } from "react/jsx-runtime";
const getDurationLabel = unit => I18n.text(`report-customization-components.customization-components.conditional-formatting.duration-options.${unit}`);
export const DurationSelect = ({
  selectedDuration,
  onUpdateDuration
}) => {
  const DURATION_LIST = [MILLISECONDS, SECONDS, MINUTES, HOURS, DAYS];
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "report-customization-components.customization-components.conditional-formatting.duration"
    }),
    children: /*#__PURE__*/_jsx(Select, {
      options: DURATION_LIST.map(unit => ({
        text: getDurationLabel(unit),
        value: unit
      })),
      defaultValue: selectedDuration,
      onChange: evt => {
        const newDuration = evt.target.value;
        onUpdateDuration(newDuration);
      }
    })
  });
};